<template lang="pug">
v-container
  template(v-if="selectedNetwork")
    v-card.pointer(v-for="tradePoint in tradepoints" :key="tradePoint.id" class="mx-auto mb-1 pointer" max-width="400" @click.native="goToTradePoint(tradePoint)")
      v-card-title {{ tradePoint.address }}
        v-icon(v-if="tradePoint.reportExists" color="green darken-2") mdi-check-circle
      v-card-text Количество отчётов за неделю: {{ tradePoint.countReportOfMonth }}
      div.archive-info
        span.report-info( v-if="isMerch && pointStatistic[tradePoint.id] && pointStatistic[tradePoint.id].total > 0" 
          :class="isPointSynced(tradePoint).color == 'red' ? 'report-info-red' : 'report-ingo-green'"
        ) {{ isPointSynced(tradePoint).text }}
        span( v-if="isMerch && photoStatistic[tradePoint.id]" ) Сихронизировано фото {{ photoStatistic[tradePoint.id].synced }} из {{ photoStatistic[tradePoint.id].total }}
        span(v-if="isMerch && tradePoint.cachedAt") Загружено {{ downloadDate(tradePoint) }} в {{ downloadTime(tradePoint) }}
  v-card(v-if="loading" class="mx-auto" flat max-width="50")
    v-progress-circular(:size="50" color="primary" indeterminate )

  v-card(v-if="error" class="mx-auto" max-width="400")
    v-card-title Что-то пошло не по плану
      v-spacer
      v-icon(color="red") mdi-alert
    v-card-subtitle {{ error }}



</template>


<script>
// import { networkService, tradepointService } from '@/_services'
import { mapMutations, mapState } from "vuex";
import dataService from '../../../_services/dataService';
import { offlineReportService } from "../../../_services/offlineReportService";
export default {
  props: [ 'id', 'nid'],
  data: () => ({
    loading: false,
    error: null,
    tradepoints: [],
    pointStatistic: {},
    photoStatistic: {}
  }),

  mounted() {
    if (!this.selectedNetwork) this.loadNetwork()
    else {
      this.setAppBarTitle(this.selectedNetwork.name)
    }
    this.loadTradepoints()
    window.addEventListener('app:online-sync', this.loadTradepoints)
  },

  beforeDestroy() {
    window.removeEventListener('app:online-sync', this.loadTradepoints)
  },

  destroyed() {
    this.setSelectedNetwork(null)
  },

  computed: {
    ...mapState("project", ["selectedProject"]),
    ...mapState("network", ["selectedNetwork"]),
    ...mapState("pointreport", ["selectedPoint"]),

    isMerch() {
      let role = localStorage.getItem('role')
      return role == "MERCH"
    }
  },

  methods: {
    ...mapMutations(['setAppBarTitle']),
    ...mapMutations("project", ["setSelectedProject"]),
    ...mapMutations("network", ["setSelectedNetwork"]),
    ...mapMutations("tradepoint", ["setSelectedPoint"]),

    downloadTime(point) {
      let date = new Date(point.cachedAt)
      return date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
    },

    downloadDate(point) {
      let date = new Date(point.cachedAt)
      return date.toLocaleDateString('ru-RU')
    },

    isPointSynced(point) {
      let isSyncedReport = this.pointStatistic[point.id].synced == this.pointStatistic[point.id].total
      return {
        color: isSyncedReport ? 'green' : 'red',
        text: isSyncedReport ? "Отчет синхронизирован" : "Отчет не синхронизирован"
      }
    },

    async getPointStatistic(points) {
      let statistic = {}
      for(const point of points) {
        statistic[point.id] = await offlineReportService.getPointReportStatistic(point.id)
      }
      this.pointStatistic = statistic
    },

    async getPhotoStatistic(points) {
      let statistic = {}
      for(const point of points) {
        statistic[point.id] = await offlineReportService.getPointPhotoStatistic(point.id)
      }
      this.photoStatistic = statistic
    },

    loadNetwork() {
      this.setAppBarTitle('loading')
      // networkService.loadNetwork(this.nid)
      dataService.loadNetwork(this.nid, this.id)
      .then(data => {
        this.setSelectedNetwork(data)
        this.setAppBarTitle(this.selectedNetwork.name)
      })
      .catch(error => {
        this.setAppBarTitle(this.error)
      })
    },

    loadTradepoints() {
      this.loading = true
      // tradepointService.getmytradepoints(this.id, this.nid)
      this.tradepoints = []
      dataService.getPoints(this.id, this.nid) 
      .then(data => {
        this.getPointStatistic(data)
        this.getPhotoStatistic(data)
        this.tradepoints = data
        this.loading = false
      })
      .catch(error => {
        this.error = error
        this.loading = false
      })
    },

    goToTradePoint(tp) {
      this.setSelectedPoint(tp)
      this.$router.push(`/project/${this.id}/network/${this.nid}/tradepoint/${tp.id}`)
    }
  }
}
</script>
<style scoped>
.archive-info {
  font-size: 12px;
  line-height: 22px;
  color: #00000099;
  width: 100%;
  margin-top: -10px;
  display: flex;
  padding: 0 16px 16px 16px;
  display: flex;
  flex-direction: column;
}
.report-info {
  color: red;
}
.report-ingo-green {
  color: green
}
</style>